import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import MenuReportDialogsMixin from '@/views/layout/navigation/mixins/menu-report-dialogs-mixin';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component
export default class FlowPathMixin extends mixins<MenuReportDialogsMixin,PlanLimitsMixin>(MenuReportDialogsMixin, PlanLimitsMixin) {
  @Prop()
  path: any;
  
  addOfferEvent: string = 'new-offer'; 
  editOfferEvent: string = 'edit-offer';
  deleteOfferEvent: string = 'delete-offer';
  addLandingEvent: string = 'new-landing';
  editLandingEvent: string = 'edit-landing';
  deleteLandingEvent: string = 'delete-landing';
  
  @Prop() 
  ruleIndex: number;

  @Prop() 
  pathIndex: number;

  @Prop()
  isDirectLinking: boolean;

  get currentOffersCount() {
    return this.path.offers.length;
  }

  get offersCount() {
    if (this.isDirectLinking) {
      return 0
    }

    const landing = this.path.landings?.[0];

    const mainLanding = landing
      ? this.path.landings.find((item: any) => item.id === landing.id)
      : null;

    return mainLanding ? mainLanding.offers : 0;
  }

  fixLandingCount(selectLanding: any, preserveLAndings: boolean = false) {
    if(!preserveLAndings) {
      this.path.landings = [];
      this.addLanding(selectLanding);
    }

    let deltaOffers = this.currentOffersCount - selectLanding.offers;

    if (deltaOffers < 0) {
      this.addOffer(Math.abs(deltaOffers));
    } else {
      this.delOffer(selectLanding.offers, Math.abs(deltaOffers));
    }
  }

  getGetOffer(offerCount: number = 1) {
    return new Array(offerCount)
      .fill(null)
      .map(() => {
        return {
          id: '',
          weight: 100
        }
      });
  }
  
  addOffer(offerCount: number = 1) {
    const newOffers = this.getGetOffer(offerCount);
    this.path.offers.push(...newOffers);
  }

  addNewOffer() {
    if(this.hasPlanLimitsRestriction('offersAmount')){
      return this.handleClickPlanLimits('offersAmount')
    }
    this.bus.emit(this.addOfferEvent);
  }

  editOffer(id: string) {
    this.bus.emit(this.editOfferEvent, id);
  }

  previewOffer(url: string) {
    window.open(url, '_blank');
  }

  delOffer(offerIndex: number, count: number = 1) {
    this.path.offers.splice(offerIndex, count);
    this.bus.emit(this.deleteOfferEvent, this.ruleIndex, this.pathIndex, offerIndex);
  }

  addLanding(landing: any = { id: '' }) {
    this.path.landings.push({
      ...landing,
      weight: 100
    });
  }

  addNewLanding() {
    if(this.hasPlanLimitsRestriction('landingsAmount')){
      return this.handleClickPlanLimits('landingsAmount')
    }
    this.bus.emit(this.addLandingEvent);
  }

  editLanding(id: string) {
    this.bus.emit(this.editLandingEvent, id);
  }

  previewLanding(url: string) {
    window.open(url, '_blank');
  }

  delLanding(landingIndex: number) {
    this.path.landings.splice(landingIndex, 1);
    this.bus.emit(this.deleteLandingEvent, this.ruleIndex, this.pathIndex, landingIndex);
  }

  countWeight(item: any, arr: any) {
    let p = 0;

    if (Number(item) !== 0) {
      let sum: any = 0;
      arr.forEach((e: any) => {
        if (e.status === 'inactive') {
          return;
        } 

        sum += +e.weight;
      });

      if (sum !== 0)
        p = (item.weight * 100) / sum;
    }

    return Math.round(p);
  }

  getTotalWeightOf(weights: any[]) {
    return weights
      .map((item) => +item.weight)
      .reduce((acc: number, item: number) => acc + item, 0);
  }

  get totalWeightOfLandings() {
    return this.getTotalWeightOf(this.path.landings); 
  }

  get totalWeightOfOffers() {
    return this.getTotalWeightOf(this.path.offers); 
  }
}
